module.exports = __webpack_public_path__ + "media/images/countryrect/cy-84e1b83c6962a00d926759eae0926c49.svg";